import { useMemo } from "react";
import { DocsKind } from "./constants";
import docs from "@redriver/cinnamon-mui/docs/typedoc.json";

const useDocs = (entry, kind, namespace) => {
  const kinds = useMemo(
    () => (Array.isArray(kind) ? kind : kind ? [kind] : []),
    [kind]
  );

  return useMemo(() => {
    const sources = namespace
      ? docs?.children?.find(
          (c) => c.name === namespace && c.kind === DocsKind.Namespace
        )?.children
      : docs?.children;
    const matches = sources?.filter(
      (c) =>
        c.name === entry &&
        (kinds.length === 0 || kinds.some((k) => k === c.kind))
    );
    if (!matches || matches.length !== 1) return null;
    return matches[0];
  }, [entry, kinds, namespace]);
};

export default useDocs;
